module.exports = function() {
  return new Worker(__webpack_public_path__ + "17a2fd6aa491d6349382.worker.js");
};